<template lang='pug'>
.popup-item.makeSticky--top0
  .popup-datePickersWrapper
    .popup-option.popup-calendar
      span(:class='selected1 ? "color--black90" : "color--greyCharcoal30"') {{ this.start }}
      i.icon-calendar.popup-icon--toRight
    span.popup-calendarText 至
    .popup-option.popup-calendar
      span(:class='selected2 ? "color--black90" : "color--greyCharcoal30"') {{ this.end }}
      i.icon-calendar.popup-icon--toRight
</template>
<script>
export default {
  props: {
    startDate: String,
    endDate: String,
    placeHolder: String
  },
  data() {
    return {
      date: this.placeHolder? this.placeHolder: '年/月/日'
    }
  },
  computed: {
    start() {
      return this.startDate ? this.startDate : this.date
    },
    end() {
      return this.endDate ? this.endDate : this.date
    },
    selected1() {
      return this.startDate ? true : false
    },
    selected2() {
      return this.endDate ? true : false
    }
  }
}
</script>
